module.exports = __webpack_public_path__ + "img/blanc.c54db749.jpg";